export default __webpack_public_path__ + "static/media/coins.140f1bc5.png";